import axios from 'axios'
import mutations from '@/store/mutation-types'
import actions from '@/store/action-types'

export default {
  state: {
    externalChannels: false,
    open: false,
    joined: false,
    status: '活动已结束',
    activityStatus: 0
  },
  mutations: {
    [ mutations.update.ACTIVITY_STATUS ] (state, payload) {
      if (payload.activityStatus === 0) {
        state.status = '活动尚未开始'
      } else if (payload.activityStatus === 2) {
        state.status = '活动已结束'
      } else {
        state.open = true
        state.status = '立即参加'
      }
      state.activityStatus = payload.activityStatus
      state.joined = payload.joined
    },
    [ mutations.update.JOININ_ACTIVITY ] (state) {
      state.joined = true
      state.open = true
      state.status = '立即参加'
    },
    [ mutations.update.IS_EXTERNAL_CHANNELS ] (state) {
      state.externalChannels = true
      state.status = '立即参加'
    }
  },
  actions: {
    [ actions.fetch.ACTIVITY_STATUS ] ({ commit, rootState }) {
      return axios.get(`${rootState.API_BASE_URL}/join`, {
        params: rootState.urlParams
      }).then(({ data }) => {
        commit(mutations.update.ACTIVITY_STATUS, data)
      }).catch(error => {
        console.log(`${actions.fetch.ACTIVITY_STATUS}: ${error}`)
      })
    },
    [ actions.post.JOININ_ACTIVITY ] ({ commit, rootState }) {
      return axios.post(`${rootState.API_BASE_URL}/join`, {
        ...rootState.urlParams
      }).then(({ data }) => {
        if (data.success) {
          commit(mutations.update.JOININ_ACTIVITY)
        }
      }).catch(error => {
        console.log(`${actions.post.JOININ_ACTIVITY}: ${error}`)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/activity.js